"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTemplate = void 0;
var useTemplate_1 = require("./useTemplate");
Object.defineProperty(exports, "useTemplate", { enumerable: true, get: function () { return useTemplate_1.useTemplate; } });
//# sourceMappingURL=index.js.map